import { CommonModule } from '@angular/common';
import { Component, ComponentRef, DestroyRef, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import Swiper, { Mousewheel } from 'swiper';

@Component({
  selector: 'app-people-list-swiper',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './people-list-swiper.component.html',
  styleUrl: './people-list-swiper.component.css'
})
export class PeopleListSwiperComponent {
  @Input() swiperItems: Array<{ title: string; description: string; img: string }> = [];

  lang: string = '';

  private translocoService = inject(TranslocoService);
  private destroyRef = inject(DestroyRef);
  private swiper!: Swiper;

  ngOnInit(): void {
    this.swiper = new Swiper('.swiper', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: false,
      modules: [Mousewheel],
      mousewheel: {
        releaseOnEdges: true,
      },
      touchReleaseOnEdges: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    this.translocoService.langChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((lang: string) => {
        this.lang = lang;
      });
  }

  navigatePrev() {
    console.log(this.swiper)
    this.swiper?.slidePrev();
  }

  navigateNext() {
    this.swiper?.slideNext();
  }
}
